import { useMutation, useQueryClient } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';

import { OrganisationTokenQueryKeys } from './queryKeys';
import { IDefaultResponseWithData } from './../../types/system/DefaultResponse';
import { OrganisationTokenCreateRequest, OrganisationTokenCreateResponse } from '../../types/OrganisationToken/OrganisationToken';

export default function useOrganisationTokenMutations() {
  const queryClient = useQueryClient();
  const { post, del } = useApiHelper();

  const create = useMutation({
    mutationFn: (tokenData: OrganisationTokenCreateRequest) =>
      post<
        OrganisationTokenCreateRequest,
        IDefaultResponseWithData<OrganisationTokenCreateResponse>
      >('/v1/organisation/tokens', tokenData),
    onSettled: () => {
      queryClient.invalidateQueries(OrganisationTokenQueryKeys.all());
    },
  });

  const remove = useMutation({
    mutationFn: (tokenId: string) => del(`/v1/organisation/tokens/${tokenId}`),
    onSettled: () => {
      queryClient.invalidateQueries(OrganisationTokenQueryKeys.all());
    },
  });

  return { create, remove };
}
